import EntityStateActionTypeEnum from '../../../../../constants/enums/EntityStateActionTypeEnum';
import type { FSA } from '../../../base/fsa';
import createEntityDetailActionName from './createEntityDetailActionName';

const createEntityDetailClearAction = (entityType: string, namespace: string): FSA => ({
  type: createEntityDetailActionName(entityType, EntityStateActionTypeEnum.Clear, namespace),
});

export default createEntityDetailClearAction;
